var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -398 1820 1820",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M910.317037 172.562963C723.247407 172.562963 570.785185 325.025185 570.785185 512.094815c0 186.974815 152.462222 339.531852 339.531852 339.531852s339.721481-152.651852 339.721482-339.531852c0-187.06963-152.557037-339.531852-339.721482-339.531852z m0 632.225185c-161.185185 0-292.503704-131.697778-292.503704-292.693333 0-161.374815 131.318519-292.314074 292.503704-292.314074 161.28 0 292.693333 130.939259 292.693333 292.314074 0 160.995556-131.318519 292.693333-292.693333 292.693333z",
    fill: "#00ff1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.087407 497.682963c7.205926 13.463704 17.066667 29.771852 25.220741 45.700741 8.343704 16.213333 20.574815 38.684444 20.574815 38.684444s35.934815-74.714074 61.724444-113.493333c65.801481-98.702222 127.051852-122.121481 127.051852-122.121482s-6.352593 52.717037-5.688889 73.955556c0.758519 24.272593 10.808889 52.242963 10.808889 52.242963s-56.604444 32.900741-110.269629 90.832592c-33.848889 36.598519-79.36 108.468148-79.36 108.468149s-38.4-46.743704-68.645926-70.542223c-33.564444-26.453333-73.671111-47.881481-73.671111-47.881481s33.28-21.807407 50.157037-32.711111c16.971852-10.808889 42.097778-23.134815 42.097777-23.134815z",
    fill: "#00fa11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.3cba804338cefbcbe66ede690b55618d.svg";
export { ForwardRef as ReactComponent };